module.exports = __webpack_public_path__ + "static/media/medalDefault.aa5d5da5.png";